import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import React, {useEffect, PropsWithChildren, Fragment} from "react";
import {IHOCLiveScoreController} from "views/components/hoc_live_score/hoc_live_score.controller";

export const HOCLiveScore: React.FC<PropsWithChildren> = ({children}) => {
	const controller = useViewController<IHOCLiveScoreController>(Bindings.HOCLiveScoreController);

	useEffect(() => {
		controller.subscribeLiveScoring();

		return () => {
			controller.unsubscribeLiveScoring();
		};
	}, [controller]);

	return <Fragment>{children}</Fragment>;
};
